import { render } from "./project-list-model.vue?vue&type=template&id=33a8bf04"
import script from "./project-list-model.vue?vue&type=script&lang=js"
export * from "./project-list-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__